"use client";

import { Heading, Text } from "@/components/ui/typography";

const approachItems = [
  "Incorporation Setup",
  "Banking Preparation",
  "Accounting Coordination",
  "Corporate Secretary Support",
];

const missionItems = ["Clear", "Accessible", "Compliant", "Efficient"];

function TickItem({ text }: { text: string }) {
  return (
    <div className="flex items-center gap-3">
      <img
        className="max-sm:h-[19px] max-sm:w-[19px]"
        src="/company-formation/tick_mark.svg"
        alt="Tick Mark"
      />
      <span className="text-[16px] font-inter font-medium leading-[150%] text-white max-sm:text-[16px]">
        {text}
      </span>
    </div>
  );
}

type Props = {
  approachHeading?: string;
  teamAssistsHeading?: string;
  missionHeading?: string;
};

export default function OurVision({
  approachHeading = "Our Approach",
  teamAssistsHeading = "Our Team Assists With:",
  missionHeading = "Our Mission",
}: Props = {}) {
  return (
    <section className="bg-black px-4 pb-[30px] md:pb-[60px]">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-[48px] lg:grid-cols-2">
        <div className="rounded-[32px] bg-[#0f1218] px-[60px] py-[52px] max-sm:rounded-[28px] max-sm:px-6 max-sm:py-8">
          <Heading as="h2" variant="cardTitleLight" className="text-[32px] leading-[110%] max-sm:text-[32px]">
            {approachHeading}
          </Heading>

          <Text variant="muted" className="mt-6 max-w-[476px] max-sm:text-[16px]">
            MuteTaxes combines expert coordination with a high-touch support
            experience. We don&apos;t just tell you what to do. We help execute
            the entire process properly.
          </Text>

          <Heading as="h3" variant="cardTitleLight" className="mt-6 text-[32px] leading-[110%] max-sm:text-[32px]">
            {teamAssistsHeading}
          </Heading>

          <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-5 max-sm:grid-cols-1">
            {approachItems.map((item) => (
              <TickItem key={item} text={item} />
            ))}
          </div>
        </div>

        <div className="rounded-[32px] bg-[#0f1218] px-[60px] py-[52px] max-sm:rounded-[28px] max-sm:px-6 max-sm:py-8">
          <Heading as="h2" variant="cardTitleLight" className="text-[32px] leading-[110%] max-sm:text-[32px]">
            {missionHeading}
          </Heading>

          <Text variant="muted" className="mt-6 max-w-[476px] max-sm:text-[16px]">
            We believe founders should spend more time growing their business,
            not navigating outdated systems and unnecessary tax burdens.
            <br />
            Our mission is to make international business structuring:
          </Text>

          <div className="mt-8 grid grid-cols-2 gap-x-8 gap-y-5 max-sm:grid-cols-1">
            {missionItems.map((item) => (
              <TickItem key={item} text={item} />
            ))}
          </div>

          <p className="mt-10 max-w-[520px] text-[16px] font-medium font-inter leading-[24px] text-white max-sm:text-[16px]">
            By combining strategic guidance with hands-on execution, we help
            entrepreneurs create structures built for long-term growth.
          </p>
        </div>
      </div>
    </section>
  );
}
